<span [ngClass]="{'text-danger': difference < 0, 'text-muted': variance === null}">
  <span>{{difference | rdoCurrency:true:translateService.currentLang}}</span>
  /
  @if (variance !== null) {
    <span>{{variance | percent:'1.1-1'}}</span>
  }
  @if (variance === null) {
    <span>-</span>
  }
</span>
